module.exports = __webpack_public_path__ + "img/house_and_funeral.6ffd1459.svg";